import React, { useState, useEffect } from "react";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useParams } from "react-router-dom";
import { getRetailerView, updateRetailer } from "./service";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const RetailerView = () => {

    const [retailerData, setRetailerData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [editUserData, setEditUserData] = useState({
        name: "",
        username: "",
        company_name: "",
        mobile_number: "",
        email: "",
        address: "",
        country: "",
        state: "",
        city: ""
    })

    const params = useParams();
    console.log(params, "id")

    useEffect(() => {
        fetchData();
    }, [params.id]);

    useEffect(() => {
        if (params.isEdit === 'true') {
            setIsEdit(true);
        }
    }, [params.isEdit]);


    const notify = (message) => {
        toast.success(message, {
            theme: "colored",
            position: "top-right",
            className: 'custom-toast',
        });
    }

    const errorNotify = (message) => {
        toast.error(message, {
            theme: "colored",
            position: "top-right",
            className: 'custom-toast',
        });
    }

    console.log("getRetailerView", retailerData)
    const fetchData = async () => {
        try {
            const response = await getRetailerView(params.id)
            if (response.status === 200 || response.status === 201) {
                setRetailerData(response.data);
                setEditUserData(response.data)
            }

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    const handleUpdate = async () => {
        const updatedData = {
            id: params.id,
            full_name: editUserData.name,
            username:editUserData.username,
            company_name: editUserData.company_name,
            mobile_number: editUserData.mobile_number,
            country: editUserData.country,
            state: editUserData.state,
            city: editUserData.city,
            address: editUserData.address,
            email: editUserData.email
        };
        console.log("updatedData", updatedData)

        try {
            const response = await updateRetailer(params.id, updatedData);
            if (response.status === 200 || response.status === 201) {
                console.log("Update successful:", response.data);
                fetchData();
                notify(response.data.message);

            } else {
                console.error("Error updating data:", response.statusText);
            }
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };

    const handleOnChange = (e) => {
        setEditUserData({ ...editUserData, [e.target.name]: e.target.value })
    }

    return (
        <>
            <ToastContainer />
            <Container maxWidth="xxl" className="pt-4 pb-4">
                <div className="header-text-wrap">
                    <div>
                        <h2 className="header-text">Retailer View</h2>
                    </div>
                </div>
            </Container>
            <Container maxWidth="xxl" className="pt-2 pb-4">
                <Grid container spacing={{ xs: 2, md: 3 }}>
                    <Grid item xs={12} sm={12} md={8} lg={6}>
                        <div className="user-view-box">
                            <div>
                                <h6>Retailer Details</h6>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">Name :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {isEdit ? (
                                        <>
                                            <input
                                                // variant="filled"
                                                name="name"
                                                value={editUserData.name}
                                                onChange={(e) => handleOnChange(e)}
                                                className='detail-input'
                                            />
                                        </>
                                    ) : (
                                        <span className="detail-value">{retailerData.name ? retailerData.name : '-'}</span>
                                    )}
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">User name :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {isEdit ? (
                                        <>
                                            <input
                                                // variant="filled"
                                                name="username"
                                                value={editUserData.username}
                                                onChange={(e) => handleOnChange(e)}
                                                className='detail-input'
                                            />
                                        </>
                                    ) : (
                                        <span className="detail-value">{retailerData.username ? retailerData.username : '-'}</span>
                                    )}
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">Password :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    <span className="detail-value">{retailerData.current_password ? retailerData.current_password : '-'}</span>
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">Company name :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {
                                        isEdit ? (
                                            <>
                                                <input
                                                    value={editUserData.company_name}
                                                    name="company_name"
                                                    onChange={(e) => handleOnChange(e)}
                                                    className='detail-input'
                                                />
                                            </>
                                        ) : (
                                            <span className="detail-value">{retailerData.company_name ? retailerData.company_name : '-'}</span>

                                        )
                                    }
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">Mobile :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {
                                        isEdit ? (
                                            <input
                                                value={editUserData.mobile_number}
                                                name="mobile_number"
                                                onChange={(e) => handleOnChange(e)}
                                                className='detail-input'
                                            />

                                        ) : (
                                            <span className="detail-value">{retailerData.mobile_number ? retailerData.mobile_number : '-'}</span>

                                        )
                                    }
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">Email id :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {
                                        isEdit ?
                                            (
                                                <input
                                                    value={editUserData.email}
                                                    name="email"
                                                    onChange={(e) => handleOnChange(e)}
                                                    className='detail-input'
                                                />

                                            ) : (
                                                <span className="detail-value">{retailerData.email ? retailerData.email : '-'}</span>

                                            )
                                    }
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">parent name :</span>
                                </div>
                                <div>
                                    <span className="detail-value">{retailerData.created_by ? retailerData.created_by : '-'}</span>
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">Owner Name :</span>
                                </div>
                                <div>
                                    <span className="detail-value">{retailerData.name ? retailerData.name : '-'}</span>
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">country :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {
                                        isEdit ? (
                                            <input
                                                value={editUserData.country}
                                                name="country"
                                                onChange={(e) => handleOnChange(e)}
                                                className='detail-input'
                                            />
                                        ) : (
                                            <span className="detail-value">{retailerData.country ? retailerData.country : '-'}</span>

                                        )
                                    }
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">State :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {
                                        isEdit ? (
                                            <input
                                                value={editUserData.state}
                                                name="state"
                                                onChange={(e) => handleOnChange(e)}
                                                className='detail-input'
                                            />
                                        ) : (
                                            <span className="detail-value">{retailerData.state ? retailerData.state : '-'}</span>

                                        )
                                    }
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">City :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {
                                        isEdit ? (
                                            <input
                                                value={editUserData.city}
                                                name="city"
                                                onChange={(e) => handleOnChange(e)}
                                                className='detail-input'
                                            />
                                        ) : (
                                            <span className="detail-value">{retailerData.city ? retailerData.city : '-'}</span>

                                        )
                                    }
                                </div>
                            </div>
                            <div className="user-detail-wrap">
                                <div className="user-detail">
                                    <span className="detail-label">Address :</span>
                                </div>
                                <div className="user-detail-input-wrap">
                                    {
                                        isEdit ? (
                                            <input
                                                value={editUserData.address}
                                                name="address"
                                                onChange={(e) => handleOnChange(e)}
                                                className='detail-input'
                                            />
                                        ) : (
                                            <span className="detail-value">{retailerData && retailerData.address ? retailerData.address : '-'}</span>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
            <div className="disatributer-update-button-wrap">
                {isEdit ? (
                    <>
                        <button onClick={handleUpdate} className='disatributer-update-button mb-4'>
                            Update
                        </button>
                    </>
                ) : ("")}
            </div>

        </>
    );
}

export default RetailerView;
